import { LongList } from '@store/abstract/LongList';

export class SimpleLongList<T, F = null, I = string> extends LongList<T, T, F, I> {
    protected create(params: T): T {
        return params;
    }
}
